import { render } from "./ApartmentsHeader.vue?vue&type=template&id=248a96f8&scoped=true"
import script from "./ApartmentsHeader.vue?vue&type=script&lang=js"
export * from "./ApartmentsHeader.vue?vue&type=script&lang=js"

import "./ApartmentsHeader.vue?vue&type=style&index=0&id=248a96f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-248a96f8"

export default script